import { FC } from 'react'
import { useIntl } from 'react-intl'

type Props = {
  onStart: () => void
  isPending?: boolean
  /**
   * `finding` invites a question about the vulnerability in scope; `free` opens
   * a chat with no subject at all. Only the copy differs — the action is a
   * create either way.
   */
  variant?: 'finding' | 'free'
}

const COPY = {
  finding: {
    title: 'Start a conversation',
    subtitle: 'Create a chat to ask the AI about this vulnerability.',
    button: 'Create new chat',
  },
  free: {
    title: 'CHAT.FREE.START_TITLE',
    subtitle: 'CHAT.FREE.START_SUBTITLE',
    button: 'CHAT.FREE.START_BUTTON',
  },
} as const

const ChatStartState: FC<Props> = ({ onStart, isPending = false, variant = 'finding' }) => {
  const intl = useIntl()
  const copy = COPY[variant]

  return (
    <div className='lum-empty'>
      <div className='lum-orb-lg'>✦</div>
      <h4 className='lum-empty-title'>{intl.formatMessage({ id: copy.title })}</h4>
      <p className='lum-empty-sub'>{intl.formatMessage({ id: copy.subtitle })}</p>
      <button type='button' className='lum-start-btn' onClick={onStart} disabled={isPending}>
        {intl.formatMessage({ id: copy.button })}
      </button>
    </div>
  )
}

export default ChatStartState
